import styled from 'styled-components';
import TwitterPic from '../assets/twitter.svg';
import FaucetPic from '../assets/faucet.jpg';
import { useState } from 'react';
import { useAlert } from "react-alert"
const Wrapper = styled.div`
  padding-top: 120px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 1200px){
    width: 1170px;
  }
  @media (min-width: 992px) and (max-width: 1199px)
    width: 970px;
  }
  @media (min-width: 768px) and (max-width: 991px){
    width: 750px;
  }
`
const Header = styled.h3`
  font-size: 36px;
  text-align: center;
  img {
    margin-right: 10px;
  }
 
`
const EnterURL = styled.div`
  display: flex;
  max-width: 740px;
  margin: 50px auto;
  input {
    flex: 1;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px 0 0 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    outline-style: none;
  }
  button {
    height: 34px;
    border: 1px solid #ccc;
    border-radius: 0 4px 4px 0;
    padding: 6px 12px;
    font-size: 14px;
    margin-left: -1px;
    cursor: pointer;
    display: flex;
    span {
      position: relative;
      top: 2px;
    }
  }
`

const Des = styled.div`
  h3 {
    font-size: 24px;
    margin-top: 100px;
    margin-bottom: 10px;
  }
  p {
    margin: 0 0 10px;
    line-height: 1.42857143;
  }
  dl {
    margin: 15px 0 20px;
    p {
      margin: 0 0 5px;
    }
    display: flex;
    img {
      position: relative;
      top: 42px;
      width: 36px;
      height: 36px;
      margin-right: 30px;
      margin-left: 30px;
    }
  }
`
// console.log(fetch)

function CheckUrl (str) { 
	const RegUrl = new RegExp()
	RegUrl.compile("^[A-Za-z]+://[A-Za-z0-9-_]+\\.[A-Za-z0-9-_%&\?\/.=]+$")
	if (!RegUrl.test(str)) { 
	  return false
	} 
  return true
}
const SEND_URL = 'https://api-divergence-protocol.com/twitter'
function App() {
  const alert = useAlert();
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(false)
  
  const requestTestCoin = async () => {
    if (CheckUrl(url)) {
      const _id = url.split('/')[5].split('?')[0]
      if (_id !== undefined) {
        setLoading(true)
        fetch(`${SEND_URL}?id=${_id}`)
          .then(res => res.json())
          .then(res => {
            // console.log(res)
            if (res.status === 'success') {
              setUrl('')
              alert.success(res.comment)
            } else {
              alert.error(res.comment)
            }
            setLoading(false)
          })
          .catch(error => {
            console.error(error)
            alert.error('Network error')
            setLoading(false)
          })
      } else {
        alert.error('Invalid input URL')
      }
    } else {
      alert.error('Invalid input URL')
    }
  }
  return (
    <Wrapper>
      <Header>
        <img width="36px" src={FaucetPic} alt="icon"/>
        Divergence Kovan Testnet Faucet
      </Header>
      <EnterURL>
        <input onChange={(event) => {setUrl(event.target.value)}} value={url} id="url" name="url" type="text" className="form-control" placeholder="Twitter Post URL containing your Ethereum Address"></input>
        <button disabled={loading} onClick={requestTestCoin}>
          {loading && <div className="loader"></div>}
          <span>Request DAI</span>
        </button>
      </EnterURL>
      <Des>
        <h3>How does this work?</h3>
        <p>To request funds, please: </p>
        <dl>
          <dt>
            <img src={TwitterPic} alt="twitter-icon"/>
          </dt>
          <dd>
            <p>
              1) Make a&nbsp;
              <a href="https://twitter.com/intent/tweet?text=I am joining Divergence’s Mock Option Trading Battle on Arbitrum Rinkeby Testnet: 0x0000000000000000000000000000000000000000 https://link.medium.com/4MSPkdBnXib" target="_about:blank">tweet</a>
              &nbsp;with your Ethereum address pasted into the contents (simply change the address in the sample post);
            </p>
            <p>
              2) Copy-paste the tweets URL into the above input box;
            </p>
            <p>
              3) Click “request DAI” and wait for the tokens to arrive in your wallet!
            </p>
            <p>
              4) Join our <a target="_about:blank" href="https://discord.gg/v96fhsPfRa">discord</a> channel for more discussions with with team and other traders!
            </p>
            <p>
              5) Test DAI Contract Address: 0xf70239947b7044bf17d26fc718c79afa5cd1382f
            </p>
          </dd>
        </dl>
        <p>Notes: Each Twitter account and each Ethereum address can only request the test token once. Your Twitter handle, and Ethereum address will be stored by our server and later published and shown on the participation leaderboard. </p>
      </Des>
    </Wrapper>
    // <a 
    //   href="https://twitter.com/intent/tweet?
    //     original_referer=
    //       https%3A%2F%2Fdeveloper.twitter.com%2F&amp;
    //       ref_src=twsrc%5Etfw&amp;
    //       text=Guides%20%7C%20Docs%20%7C%20Twitter%20Developer%20Platform&amp;
    //       tw_p=tweetbutton&amp;
    //       url=https%3A%2F%2Fdeveloper.twitter.com%2Fen%2Fdocs%2Ftwitter-for-websites%2Ftweet-button%2Foverview" class="btn" id="b">
    //   <i></i><span class="label" id="l">Tweet</span>
    // </a>
  );
}

export default App;
